import { render, staticRenderFns } from "./IncRnaGoKegg.vue?vue&type=template&id=bbc478c6&scoped=true"
import script from "./IncRnaGoKegg.vue?vue&type=script&lang=js"
export * from "./IncRnaGoKegg.vue?vue&type=script&lang=js"
import style0 from "./IncRnaGoKegg.vue?vue&type=style&index=0&id=bbc478c6&prod&scoped=true&lang=css"
import style1 from "./IncRnaGoKegg.vue?vue&type=style&index=1&id=bbc478c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc478c6",
  null
  
)

export default component.exports